export default __webpack_public_path__ + "static/media/big_cat.31cc505b.jpg";